import {useCA} from 'api';
import Form from '../Form';

export default function HasItemId({caId}) {
  const item = useCA(caId);
  return (
    <Form corporateAction={item}/>
  );
}
